import { Facility } from 'apps/marketplace/apiTypes/facilities'
import { ShipperFacility } from '../../../apiTypes/shipperFacilities'
import { TFacilityExtraView } from '../components/FacilityExtra/FacilityExtraFormSchema'

export const getFacilityExtra = (facility?: Facility): TFacilityExtraView => {
  const {
    arrivalInstructions,
    equipments,
    relayPaymentsNetworkStatus,
    requirements,
    safetyRequirements,
    services,
  } = facility?.extra || {}
  return {
    requirements: {
      value: requirements || [],
      overridden: false,
    },
    equipments: {
      value: equipments || [],
      overridden: false,
    },
    services: {
      value: services || [],
      overridden: false,
    },
    arrivalInstructions: {
      value: arrivalInstructions || '',
      overridden: false,
    },
    safetyRequirements: {
      value: safetyRequirements || '',
      overridden: false,
    },
    relayPaymentsNetworkStatus: {
      value: relayPaymentsNetworkStatus || 'unknown',
      overridden: false,
    },
  }
}

export const getShipperFacilityExtra = (
  facility: ShipperFacility | undefined
): TFacilityExtraView => {
  const {
    arrivalInstructions,
    equipments,
    relayPaymentsNetworkStatus,
    requirements,
    safetyRequirements,
    services,
  } = facility?.extra || {}
  return {
    requirements: {
      value: requirements?.value || [],
      overridden: requirements?.overridden || false,
    },
    equipments: {
      value: equipments?.value || [],
      overridden: equipments?.overridden || false,
    },
    services: {
      value: services?.value || [],
      overridden: services?.overridden || false,
    },
    arrivalInstructions: {
      value: arrivalInstructions?.value || '',
      overridden: arrivalInstructions?.overridden || false,
    },
    safetyRequirements: {
      value: safetyRequirements?.value || '',
      overridden: safetyRequirements?.overridden || false,
    },
    relayPaymentsNetworkStatus: {
      value: relayPaymentsNetworkStatus?.value || 'unknown',
      overridden: relayPaymentsNetworkStatus?.overridden || false,
    },
  }
}
